/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'
import moment from 'moment'

import {
  NavLink,
  Spinner
} from '../'

import {
  decodeBase64
} from '../../utils'

class RelatedCase extends React.Component {
  static propTypes = {
    anchorText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    errorText: PropTypes.string,
    noCaseFoundDisplay: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    fetchLatest: PropTypes.bool,
    showCaseStatus: PropTypes.bool
  }

  static defaultProps = {
    errorText: "Failed to load case data.",
    noCaseFoundDisplay: "No related case found.",
    fetchLatest: true,
    showCaseStatus: false
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' size='x-small' />
    }

    if (this.props.data.error) {
      return (
        <div className='slds-text-color_error'>
          {this.props.errorText}
        </div>
      )
    }

    let caseRelations = this.props.data.caserelations.edges
    if (caseRelations.length === 0) {
      return this.props.noCaseFoundDisplay
    }

    let caseRecord = caseRelations[0].node.case

    return (
      <NavLink to={`/os/identity/${caseRecord.affects.id}/cases/${caseRecord.id}`}>
        {this.props.anchorText ||
          `${moment(caseRecord.createdAt).format('MMM DD, YYYY')}${this.props.showCaseStatus
            ? ` (${caseRecord.status})`
            : ''}`}
      </NavLink>
    )
  }
}

const getCaseRelations = gql`
  query($objectId: UUID, $contentTypeModel: String!, $orderBy: String) {
    caserelations(objectId: $objectId, contentType_Model: $contentTypeModel, orderBy: $orderBy, first: 1) {
      edges {
        node {
  				id
          case {
            ...CaseInformation
          }
          contentType {
            id
            model
          }
          objectId
          createdAt
        }
      }
    }
  }
  ${fragments.caseInformation}
`

const withData = graphql(getCaseRelations, {
  options: (ownProps) => ({
    variables: {
      objectId: decodeBase64(ownProps.objectId),
      contentTypeModel: ownProps.contentTypeModel,
      orderBy: ownProps.fetchLatest ? "-created_at" : "created_at"
    },
    fetchPolicy: 'network-only'
  })
})

export default withData(RelatedCase)



// WEBPACK FOOTER //
// ./src/components/related-case/index.js